/*
 * @Author: linhao hao.lin@biz-united.com.cn
 * @Date: 2026-05-26 17:04:41
 * @LastEditors: linhao hao.lin@biz-united.com.cn
 * @LastEditTime: 2026-07-29 15:40:14
 * @FilePath: \crm-product\src\views\performanceCalculation\views\import_statement\product_price\form\index.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import Form, {
  formCreate,
} from '@/found/components/form';
import request from '@/found/utils/request';
import ChooseList from './choose_list.vue';

formCreate.component('ChooseList', ChooseList);

export default {
  extends: Form,
  components: {
    formCreate: formCreate.$form(),
  },
  data() {
    return {

    };
  },
  async created() {
    await this.getFormRule('main-form');
  },
  methods: {
    // 设置规则
    setRule(item) {
      const v = item;
      if (v.field === 'budgetSubjectsName') {
        v.props = {
          ...v.props,
          params: {
            functionCode: 'budgetSubject-list',
            parentCode: 'CRM20260728000000002',
            paramData: {},
          },
          title: '选择预算科目',
        };
        v.on = {
          ...v.on,
          change: (e) => {
            if (e && e.length) {
              const obj = e[0];
              this.setValue({
                budgetSubjectsName: obj.budgetSubjectsName,
                budgetSubjectsCode: obj.budgetSubjectsCode,
              });
            }
          },
        };
      }
      return v;
    },
    // 渲染完成后执行
    formComplete() {
      const {
        code,
      } = this.formConfig;
      if (code === 'view' || code === 'edit') {
        request.get('/dms/dmsTransferBudgetConfig/findById', {
          id: this.formConfig.row.id,
        }).then((res) => {
          if (res.success) {
            const {
              result,
            } = res;
            this.setValue({
              ...result,
            });
          }
        });
      }
    },
    submit() {
      const formData = this.getFormData(); // 获取表单的值
      if (formData) {
        let url = '/dms/dmsTransferBudgetConfig/add';
        const params = {
          ...formData,
        };
        if (this.formConfig.code === 'edit') {
          url = '/dms/dmsTransferBudgetConfig/update';
          params.id = this.formConfig.row.id;
        }
        request.post(url, params).then((res) => {
          if (res.success) {
            this.$message({
              type: 'success',
              message: '操作成功',
            });
            this.$emit('onClose');
            this.$emit('onGetList');
          }
        });
      }
    },
  },
};
